import { IRoute } from '../../core/types';
import Routes from '../../components/Routes';
import Page404 from '../Page404/Page404';
import AmazonConnection from './AmazonConnection/AmazonConnection';
import { getAmazonDataImportStatus } from '../../core/api';
import { Loader } from '../../components/Loader/Loader';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { useEffect, useState } from 'react';
import { setAmazonDataImportStatus } from '../../core/store/amazon/amazonSlice';

import Header from '../../components/Header/Header';
import SetupCheck from './SetupCheck/SetupCheck';
import { PublicRoutesEnum, SetupCheckRoutesEnum } from '../../core/enums';
const HEADER_BLOCK_KEY = 'header';

export default function SetupCheckRoutes() {
  const dispatch = useAppDispatch();
  const amazonDataImportStatus = useAppSelector(
    (s) => s.amazon.dataImportStatus
  );

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (amazonDataImportStatus === undefined) {
      getAmazonDataImportStatus()
        .then((res) => {
          dispatch(setAmazonDataImportStatus(res.status));
        })
        .catch(console.error)
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, [amazonDataImportStatus, dispatch]);

  if (isLoading) return <Loader />;

  const routes: IRoute[] = [
    ...(amazonDataImportStatus === 'loaded'
      ? [
          {
            redirectTo: SetupCheckRoutesEnum.setup_check,
            exact: true,
            path: '/',
          },
          {
            component: SetupCheck,
            path: SetupCheckRoutesEnum.setup_check,
          },
        ]
      : [
          {
            component: AmazonConnection,
            path: '/',
            exact: true,
          },
        ]),
    {
      component: Page404,
      path: PublicRoutesEnum.Page404,
    },
    {
      path: '*',
      redirectTo: PublicRoutesEnum.Page404,
    },
  ];

  return (
    <>
      <Header blockKey={HEADER_BLOCK_KEY} />
      <Routes routes={routes} />
    </>
  );
}
